






























import {
  Component,
  Vue
} from "../vuepack";
import Button from "@/shared/components/ui/Button.vue";
import { OktaSignInWidgetBuilder } from "../oktaSignInWidgetWrapper";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";
import { useThemeStore } from "@/shared/store/theme";
import { useBiometricAuthStore } from "@/shared/store/biometricAuth";


@Component({
  components: {
    Button,
  },
})
export default class HsabBiometricAuthSetup extends Vue {

  notifierStore = useNotifierStore();
  userStore = useUserStore();
  themeStore = useThemeStore();
  biometricAuthStore = useBiometricAuthStore();

  password: string;
  isAuthenticated = false;
  pendingSetup = false;

  // Assumes there is an empty element on the page with an id of #okta-signin-container
  widget = new OktaSignInWidgetBuilder("#okta-signin-container");

  mounted () {
    this.biometricAuthStore.loadBiometricSettings();
  }

  authenticate () {
    return this.widget
      .setUsername(this.userStore.username)
      .onCustomCancelButtonClicked(() => this.cancel())
      .buildForBiometricAuthSetup()
      .showSignIn();
  }

  setupBiometricAuth () {
    this.pendingSetup = true;

    this.authenticate()
      .then(response => {
        this.isAuthenticated = true;
        return this.biometricAuthStore.enableBiometricAuth({
          username: this.userStore.username,
          password: response.data,
        }).then(response => {
          if (response) {
            this.notifierStore.setSuccess(
                this.biometricAuthStore.getBiometryType.displayValue + " setup completed successfully.");
          }
          return { success: true };
        })
          .catch(error => {
            this.pendingSetup = false;
            return { success: false, message: error };
          });
      }).then((response: {
        success: boolean,
        message: any
      }) => {
        if (!response.success) {
          this.notifierStore.setInfo(response.message);
        }
      })
      .catch(error => {
        this.notifierStore.setDanger("An error occured when setting up the biometrics auth. Please try again.");
      });
  }


  cancel () {
    this.pendingSetup = false;
  }
}
